module.exports = __webpack_public_path__ + "static/img/b31523ab7c7d426111383f518259040.1a57c820.png";